import React from 'react'
import Hero from '../components/Hero'
import Layout from '../components/PageLayout'

export default ({data}) => {

  return (
    <Layout>
      <Hero
        title='Semaine après semaine...'
        id="hero"
      />
    </Layout>      
  )
}